module.exports = __webpack_public_path__ + "img/default_user.c37194a1.svg";